import { Route, Routes } from "react-router-dom";
import EnrollmentProcessing from "./EnrollmentProcessing";

export default function EnrollmentProcessingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<EnrollmentProcessing />} />
    </Routes>
  );
}
